<template>
  <a
    :href="product.url"
    class="store-product-block"
  >
    <div class="store-product-block__thumbnail">
      <img
        v-if="product.thumbnail_url"
        :src="product.thumbnail_url"
      >
      <svg
        v-if="!product.thumbnail_url"
        data-icon="documents-earmarked"
        aria-hidden="true"
        viewBox="0 0 124 161"
      >
        <use xlink:href="/resources/app/client/dist/spritemap.svg#sprite-documents-earmarked" />
      </svg>
    </div>

    <div class="store-product-block__title">
      {{ product.name }}
    </div>

    <svg
      data-icon="arrow"
      aria-hidden="true"
      viewBox="0 0 14 11"
    >
      <use xlink:href="/resources/app/client/dist/spritemap.svg#sprite-arrow" />
    </svg>
  </a>
</template>

<script>
export default {
  name: 'Product',

  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
  },

  methods: {
  }
}
</script>
